import { setOptions } from '@googlemaps/js-api-loader';

import { locale } from '@/context';

import { getFirebaseConfig } from './firebase-config';

if (!import.meta.env.SSR) {
  const arr = locale.value.split('-');
  setOptions({
    key: getFirebaseConfig().apiKey,
    region: arr[0],
    language: arr[1],
  });
}
